import { Colors } from '~/themes/colors';
import { Box, IBoxProps } from '../Box';

export const Screen = ({
  children,
  backgroundColor = Colors.neutral_100,
  flex = 1,
  ...rest
}: IBoxProps) => (
  <Box backgroundColor={backgroundColor} flex={flex} {...rest}>
    {children}
  </Box>
);
